import { UpdateDrinkDetailAppConfigQuery as DrinkDetailData } from '../../order/UpdateDrinkDetail/__generated__/UpdateDrinkDetailAppConfigQuery';

export enum DrinkDetailMode {
  add = 'add',
  update = 'update',
}

export type OptionGroup = DrinkDetailData['menuItem']['optionGroups'][0];
export type Option = OptionGroup['options'][0];
